import * as React from 'react';

import { translate } from '~l10n/client';
import { xAgoFormatter } from '~shared/components/helpers';
import { IconDocument, IconFolder } from '~shared/components/icons/standard';
import { sortByProperty } from '~shared/components/Table/sortingFns/sortByProperty/sortByProperty';
import { commonDateSorter } from '~teacher/components/workspaces/DialogQuizItemList/DialogQuizItemList';
import { WorkspaceItem } from '~teacher/hook/workspaces/useWorkspaceItems';

/**
 * Sort config for the shared-library quiz datagrid. Kept in one module so the
 * production table (WorkspaceQuizzes / WorkspaceItemTable) and the tests share
 * a single source of truth — a regression in the default, a column's sortType,
 * or the folders-first rule is caught by `defaultSort.test.ts`.
 */

// Shared libraries default to natural (name) sort; personal libraries keep
// Recently Modified (see useColumnSortReducer).
export const SHARED_LIBRARY_DEFAULT_SORT = { id: 'name', desc: false };

export const workspaceItemColumns = [
  {
    id: 'type',
    accessor: (item) => item.type,
    customWidth: '60px',
    disableSortBy: true,
    Cell: ({ value }: { value: any }) =>
      value === 'quiz' ? <IconDocument /> : <IconFolder />,
  },
  {
    Header: translate('Name'),
    id: 'name',
    accessor: (item) => item.name,
    sortType: 'naturalLibraryName',
  },
  {
    Header: translate('Modified'),
    id: 'modified',
    customWidth: '160px',
    sortType: commonDateSorter,
    accessor: (workspaceItem: WorkspaceItem) =>
      workspaceItem.type === 'quiz'
        ? xAgoFormatter({ date: workspaceItem.publishedDate })
        : xAgoFormatter({ date: workspaceItem.createdDate }),
  },
];

// Folders sort ahead of quizzes regardless of the active column sort.
export const staticSort = (a, b) =>
  sortByProperty('type')(a.original, b.original);
